import { useTranslation } from 'react-i18next'
import DeleteButton from '@ui/elements/DeleteButton'

const useDeleteButton = () => {
  const [t] = useTranslation('common')
  const deleteButton = (itemId, popupTitle, callBack, buttonLabel = null) => {
    const buttons = [
      {
        icon: 'icon-done',
        text: t('actions.validate'),
        callback: callBack,
        cssClass: 'is-danger',
        parameter: itemId
      },
      {
        icon: 'icon-keyboard_arrow_left',
        text: t('actions.cancel'),
        cssClass: 'is-success'
      }
    ]

    return <DeleteButton
      buttons={buttons}
      message={t('messages.confirm_item_deletion', { element: popupTitle })}
      label={buttonLabel}
    />
  }

  return deleteButton
}

export default useDeleteButton